import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import B2BSection from "@/components/AboutPage/B2BSection.vue";
import IntroSection from "@/components/AboutPage/IntroSection.vue";
import StartSection from "@/components/AboutPage/StartSection.vue";
import WhySection from "@/components/AboutPage/WhySection.vue";
import { computed } from "vue";
import { useStore } from "vuex";


export default /*#__PURE__*/_defineComponent({
  __name: 'AboutPage',
  setup(__props) {

const store = useStore();
const loggedIn = computed(() => store.state.auth.status.loggedIn);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(IntroSection),
    _createVNode(WhySection),
    _createVNode(B2BSection),
    (!loggedIn.value)
      ? (_openBlock(), _createBlock(StartSection, { key: 0 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})